// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { Button, Modal } from "@insite/mobius/index";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { FC } from "react";

const enum fields {
    buttonLabel = "buttonLabel",
    title = "title",
    content = "content",
}

interface OwnProps {
    fields: {
        [fields.buttonLabel]: string;
        [fields.title]: string;
        [fields.content]: string;
    };
}

export interface CustomModalStyles {
    modal?: ModalPresentationProps;
    wrapper?: InjectableCss;
    button?: ButtonPresentationProps;
}

export const styles: CustomModalStyles = {};
type Props = OwnProps;

export const CustomModal: FC<Props> = ({ fields }) => {
    const [isVisible, setIsVisible] = React.useState(false);
    return (
        <>
            <Button
                onClick={() => {
                    setIsVisible(!isVisible);
                }}
                {...styles.button}
            >
                {fields.buttonLabel}
            </Button>
            <Modal
                headline={fields.title || undefined}
                isOpen={isVisible}
                handleClose={() => {
                    setIsVisible(false);
                }}
                {...styles.modal}
            >
                <StyledWrapper {...styles.wrapper}>{parse(fields.content, parserOptions)}</StyledWrapper>
            </Modal>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: CustomModal,
    definition: {
        group: "Basic",
        displayName: "Custom Modal",
        fieldDefinitions: [
            {
                name: fields.buttonLabel,
                displayName: "Modal Button Label",
                editorTemplate: "TextField",
                defaultValue: "Open Modal",
                isRequired: true,
                fieldType: "General",
            },
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.content,
                editorTemplate: "RichTextField",
                defaultValue: "",
                isRequired: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;